import { SystemService } from '@/api/com/MetaPattern/APP/MDA/Common/SystemService';
import { Queue } from '../../Product/IDE/Util/Queue';

/**
 * 唯一ID管理器，每次从服务器缓存一批ID
 */
export class UniqueKeyManager {
  private static _instance = new UniqueKeyManager();
  private _keys: Queue<string>;
  private _minSize: number;
  private _isLoaded: boolean;

  private constructor() {
    this._keys = new Queue<string>();
    this._minSize = 50;
    this._isLoaded = false;
    this.createKeys();
  }

  // 获取唯一实例
  public static get instance() {
    return this._instance;
  }

  /**
   * 获取唯一ID，不存在则返回null
   * @returns 唯一ID
   */
  public getUniqueKey(): string | null {
    this.createKeys();
    return this._keys.shift();
  }

  /**
   * 新创建一组ID
   */
  private createKeys() {
    if (!this._isLoaded && this._keys.size() < this._minSize) {
      this._isLoaded = true;
      SystemService.CreateUniqueKeyListAsync(this._minSize)
        .then((res) => {
          if (res) {
            res.forEach(key => this._keys.push(key));
          }
          this._isLoaded = false;
        });
    }
  }
}
